{
  "id": 15,
  "location": "cafe",
  "difficulty": "normal",
  "moves": 17,
  "kinds": 6,
  "goals": [
    { "type": "mud" },
    { "type": "collect", "kind": "cupcake", "count": 22 }
  ],
  "stars": [2500, 3460],
  "board": [
    ". . . . . . . .",
    ". . . . . . . .",
    ". . x x x x . .",
    ". . x . . x . .",
    ". . x . . x . .",
    ". . x x x x . .",
    ". . . . . . . .",
    ". . . . . . . ."
  ],
  "calibration": { "runs": 1000, "winRate": 0.847, "movesLeft": 5, "closeLosses": 0.071, "target": 0.83 }
}
